<template>
  <div>

    <Input
      v-if="selectNew"
      v-model="selectNew"
      type="text"
      class="ipt"
      @on-focus="focus"
      @on-blur="blur"
      placeholder="请选择"
      suffix="ios-arrow-down"
    />
    <Input
      v-if="!selectNew"
      v-model="select"
      type="text"
      class="ipt"
      @on-focus="focus"
      @on-blur="blur"
      placeholder="请选择"
      suffix="ios-arrow-down"
    />

    <div class="tan" v-show="tan">
      <Tree :data="selects" title-key="label" @on-select-change="check"></Tree>
    </div>
  </div>
</template>
<script >
export default {
  data() {
    return {
      selectNew: "",
      option: {},
      tan: false
    };
  },
  watch: {
   
  },
  props: ["select","selects"],
  created() {},
  methods: {
    check(index) {
      if (index.length != 0) {
        this.option = index[0];
        this.selectNew = index[0].title;
        this.$emit("selectChild", index);
      }

      this.tan = false;
    },
    focus() {
      this.tan = true;
    },
    blur() {
      //   this.tan = false
    }
  },
  mounted: function() {}
};
</script>
<style scoped>
.tan {
  margin-top: 10px;
  width: 100%;
  height: 200px;
  overflow-y: auto;
  border: 1px solid #dcdee2;
  will-change: top, left;
  transform-origin: center top;
  z-index: 900;
}
</style>